export const SECTION_TYPES = {
  NULL: 'NULL',
  ONECOL: 'ONECOL',
  TWOCOL: 'TWOCOL',
  THREECOL: 'THREECOL',
  FORMCOL: 'FORMCOL',
  FORMSUCCESSCOL: 'FORMSUCCESSCOL',
  LANDINGONECOL: 'LANDINGONECOL',
  LANDINGTWOCOL: 'LANDINGTWOCOL',
  PRODUCTSTHREECOL: 'PRODUCTSTHREECOL',
  PRODUCTSTWOCOL: 'PRODUCTSTWOCOL',
}

export const SECTION_TYPES_VALUES = Object.values(SECTION_TYPES)

export const COLUMNS_COUNT = {
  [SECTION_TYPES.NULL]: 0,
  [SECTION_TYPES.ONECOL]: 1,
  [SECTION_TYPES.TWOCOL]: 2,
  [SECTION_TYPES.THREECOL]: 3,
  [SECTION_TYPES.FORMCOL]: 2,
  [SECTION_TYPES.FORMSUCCESSCOL]: 2,
  [SECTION_TYPES.LANDINGONECOL]: 1,
  [SECTION_TYPES.LANDINGTWOCOL]: 2,
  [SECTION_TYPES.PRODUCTSTHREECOL]: 3,
  [SECTION_TYPES.PRODUCTSTWOCOL]: 2,
}

export const COLUMN_CLASS = {
  [SECTION_TYPES.NULL]: '',
  [SECTION_TYPES.ONECOL]: 'one-column',
  [SECTION_TYPES.TWOCOL]: 'two-columns',
  [SECTION_TYPES.THREECOL]: 'three-columns',
  [SECTION_TYPES.FORMCOL]: 'form-two-columns',
  [SECTION_TYPES.FORMSUCCESSCOL]: 'form-two-columns',
  [SECTION_TYPES.LANDINGONECOL]: 'one-column',
  [SECTION_TYPES.LANDINGTWOCOL]: 'two-columns',
  [SECTION_TYPES.PRODUCTSTHREECOL]: 'three-columns',
  [SECTION_TYPES.PRODUCTSTWOCOL]: 'two-columns',
}

export const SECTION_LAYOUTS = [
  { value: 'FULL_WIDTH', name: 'section.layouts.full-width' },
  { value: 'CONTENT_WIDTH', name: 'section.layouts.content-width' },
  { value: 'BOXED', name: 'section.layouts.boxed' },
]

export const SECTION_WIDTH_TYPES = [
  { value: 'SMALL', name: 'section.width-type.small' },
  { value: 'MEDIUM', name: 'section.width-type.medium' },
  { value: 'LARGE', name: 'section.width-type.large' },
]

export const SECTION_WIDTH_TYPES_CLASS = {
  [SECTION_WIDTH_TYPES[0].value]: 'max-width-sm',
  [SECTION_WIDTH_TYPES[1].value]: 'max-width',
  [SECTION_WIDTH_TYPES[2].value]: 'max-width-lg',
}

export const SECTION_VERTICAL_ALIGN = [
  { value: 'start', name: 'section.vertical-align.top' },
  { value: 'center', name: 'section.vertical-align.center' },
  { value: 'end', name: 'section.vertical-align.bottom' },
]

export const SECTION_VERTICAL_ALIGN_EMAIL_MAP = {
  [SECTION_VERTICAL_ALIGN[0].value]: 'top',
  [SECTION_VERTICAL_ALIGN[1].value]: 'middle',
  [SECTION_VERTICAL_ALIGN[2].value]: 'bottom',
}

export const TWOCOL_SECTION_BG_IMAGE_POSITION_TYPES = [
  { value: 'left', name: 'section.twocol.bgimageposition.left' },
  { value: 'both', name: 'section.twocol.bgimageposition.both' },
  { value: 'right', name: 'section.twocol.bgimageposition.right' },
]

export const FORMCOL_SECTION_BG_IMAGE_POSITION_TYPES = [
  { value: 'left', name: 'section.formcol.bgimageposition.left' },
  { value: 'top', name: 'section.formcol.bgimageposition.top' },
  { value: 'right', name: 'section.formcol.bgimageposition.right' },
  { value: 'none', name: 'section.formcol.bgimageposition.none' },
]
